// NE SURTOUT PAS METTRE D'AUTRE INTELIGENCE DANS CE FICHIER, IL EST ÉCRASÉ PAR LES PIPELINES
import { ENV } from '../../constants';

export const defaultEnv: ENV = ENV.PROD;
